module.exports = __webpack_public_path__ + "static/media/credit_platinum_travel.182194f3.svg";